var render, staticRenderFns
import script from "./ServiceObjectPropertyAdjacentParents.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectPropertyAdjacentParents.vue?vue&type=script&lang=js&"
import style0 from "./ServiceObjectPropertyAdjacentParents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable} from 'quasar'
component.options.components = Object.assign({QTable}, component.options.components || {})
